<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <transition name="slide-fade">
      <b-row v-if="MenuFlag">
        <b-col md="6" class="ml-auto mr-auto">
          <b-card title="อัพเดทสถานะงาน" class="text-center">
            <b-row>
              <b-col sm="6">
                <span class="title-freight larger-font"> User : </span>
                <span class="black-text smaller-font">{{ showUsername }}</span>
              </b-col>
              <b-col sm="6">
                <span class="title-freight larger-font">
                  {{ $t("report.accepted_req") }} :
                </span>
                <span class="black-text smaller-font">{{ showPending }}</span>
              </b-col>
              <br />
              <br />
            </b-row>
            <div class="d-flex justify-content-center">
              <b-row>
                <b-col sm="12">
                  <b-button
                    class="btn btn-info btn-round fixed-width"
                    @click="scanQRCode('Accept')"
                  >
                    <span class="black-text larger-font">
                      {{ $t("report.accept2") }}
                    </span>
                    <br /><br />
                    <span class="black-text smaller-font">(Scan QR Code)</span>
                  </b-button>
                  <br /><br />
                </b-col>
                <b-col sm="12">
                  <b-button
                    class="btn btn-success btn-round fixed-width"
                    @click="scanQRCode('Deliver')"
                  >
                    <span class="black-text larger-font">
                      {{ $t("report.deliver") }}
                    </span>
                    <br /><br />
                    <span class="black-text smaller-font">
                      (Scan QR Code)
                    </span>
                  </b-button>
                  <br /><br />
                </b-col>
                <b-col sm="12">
                  <b-button
                    class="btn btn-warning btn-round fixed-width"
                    @click="scanQRCode('Return')"
                  >
                    <span class="black-text larger-font">
                      {{ $t("report.return") }}
                    </span>
                    <br /><br />
                    <span class="black-text smaller-font">
                      (Scan QR Code)
                    </span>
                  </b-button>
                  <br /><br />
                </b-col>
                <b-col sm="12">
                  <b-button
                    class="btn btn-round fixed-width"
                    @click="scanQRCode('Change')"
                    style="
                      border-color: #7367f0 !important;
                      background-color: #7367f0 !important;
                    "
                  >
                    <span class="black-text larger-font">
                      {{ $t("report.tranfer") }}
                    </span>
                    <br /><br />
                    <span class="black-text smaller-font">
                      (Scan QR Code)
                    </span>
                  </b-button>
                  <br /><br />
                </b-col>
                <b-col sm="12">
                  <b-button
                    class="btn btn-round fixed-width"
                    @click="scanQRCode('View')"
                    variant="outline-dark"
                  >
                    <span class="black-text"> {{ $t("report.show") }} </span>
                    <br /><br />
                    <span class="black-text"> {{ $t("report.process") }} </span>
                  </b-button>
                </b-col>
                <br /><br />
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </transition>

    <transition name="slide-fade">
      <b-row v-if="!MenuFlag && !PendingFlag">
        <b-col md="6" class="ml-auto mr-auto">
          <b-card title="" class="text-center">
            <b-row>
              <b-col sm="12" v-if="strMode == 'Accept'">
                <h4 class="title-text">{{ $t("report.accept2") }}</h4>
              </b-col>
              <b-col sm="12" v-if="strMode == 'Deliver'">
                <h4 class="title-text">{{ $t("report.deliver2") }}</h4>
              </b-col>
              <b-col sm="12" v-if="strMode == 'Return'">
                <h4 class="title-text">{{ $t("report.return") }}</h4>
              </b-col>
              <b-col sm="12" v-if="strMode == 'Change'">
                <h4 class="title-text">{{ $t("report.tranfer") }}</h4>
              </b-col>
              <br />
              <br />
            </b-row>
            <div class="d-flex justify-content-center">
              <b-row>
                <b-col sm="12" v-if="isActiveCamStart">
                  <qrcode-stream @decode="onDecode" />
                </b-col>
              </b-row>
            </div>
            <div class="d-flex justify-content-center" name="delivered">
              <b-row class="pt-2">
                <b-col sm="12" class="text-right" v-if="strMode == 'Accept'">
                  <br />
                  <b-button
                    class="btn-icon btn-round"
                    variant="outline-primary"
                    @click="triggerFileInput"
                  >
                    <feather-icon icon="FolderIcon" />
                    {{ locals("select.attach") }}
                  </b-button>
                  <input
                    type="file"
                    ref="fileInput"
                    accept=".jpeg,.jpg,.png"
                    @change="onFileChange"
                    style="display: none"
                  />
                </b-col>
                <b-col
                  sm="6"
                  class="text-left order-sm-1 order-last"
                  v-if="strMode != 'Accept'"
                >
                  <b-form-group
                    label-for="i-job-no"
                    label="Job No."
                    class="title-freight"
                  >
                    <b-form-input
                      id="i-job-no"
                      v-model="dataFilter.strInqJobNo"
                      @change="orderHandler"
                      placeholder="RQMxxxxxxxxx"
                      maxlength="20"
                      :disabled="ifView"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="6"
                  class="align-items-center order-sm-2 order-first"
                  v-if="strMode != 'Accept'"
                >
                  <b-button
                    variant="outline-primary"
                    class="btn-icon btn-round mt-2"
                    @click="OpenCamera"
                    v-if="!isActiveCamStart"
                  >
                    <feather-icon icon="CameraIcon" /> {{ $t("report.open") }}
                  </b-button>
                  <b-button
                    variant="outline-danger"
                    class="btn-icon btn-round mt-2 mr-1 mb-1"
                    @click="OpenCamera"
                    v-if="isActiveCamStart"
                  >
                    <feather-icon icon="CameraOffIcon" />
                    {{ $t("report.close") }}
                  </b-button>
                  <b-button
                    class="btn-icon btn-round mt-2 mb-1"
                    variant="outline-primary"
                    @click="triggerFileInput2"
                  >
                    <input
                      type="file"
                      ref="fileInput2"
                      accept=".jpeg,.jpg,.png"
                      @change="onFileChange"
                      style="display: none"
                    />
                    <feather-icon icon="FolderIcon" />
                    {{ locals("select.attach2") }}
                  </b-button>
                </b-col>
                <b-col
                  sm="12"
                  class="text-left order-sm-4 order-last"
                  v-if="strMode != 'Accept'"
                >
                  <b-form-group
                    label-for="i-status"
                    :label="locals('inquiry.status')"
                    class="title-freight"
                  >
                    <b-form-input
                      id="i-status"
                      v-model="dataFilter.strStatus"
                      placeholder=""
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  class="text-left order-sm-5 order-last"
                  v-if="strMode == 'Change'"
                >
                  <b-form-group
                    label-for="i-upd-date"
                    :label="locals('inquiry.update_date2')"
                    class="title-freight"
                  >
                    <b-form-input
                      id="i-upd-date"
                      v-model="dataFilter.strUpdatedDateDMY"
                      placeholder=""
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  class="text-left order-sm-6 order-last"
                  v-if="strMode == 'Change'"
                >
                  <b-form-group
                    label-for="i-upd-by"
                    :label="locals('inquiry.update_by2')"
                    class="title-freight"
                  >
                    <b-form-input
                      id="i-upd-by"
                      v-model="dataFilter.strUpdatedBy"
                      placeholder=""
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  class="text-left order-sm-7 order-last"
                  v-if="strMode == 'Deliver'"
                >
                  <b-form-group
                    :label="locals('inquiry.delivery_address')"
                    label-for="i-dest-company"
                    class="title-freight"
                  >
                    <v-select
                      id="i-dest-company"
                      v-model="dataFilter.intDestBPId"
                      :placeholder="locals('select.placeholder')"
                      label="strDestLocation"
                      :options="destOption"
                      :reduce="(val) => val.intUuId"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  sm="12"
                  class="text-left order-sm-8 order-last"
                  v-if="strMode != 'Accept'"
                >
                  <label for="i-note" class="title-freight">Note</label>
                  <b-form-textarea
                    id="i-note"
                    placeholder="ส่งให้ ............"
                    rows="3"
                    v-model="dataFilter.strNote"
                    :disabled="ifView"
                  />
                </b-col>
                <b-col
                  sm="12"
                  class="text-left pt-1 order-sm-9 order-last"
                  v-if="strMode == 'Deliver'"
                >
                  <b-form-group
                    label-for="i-attach-file"
                    :label="locals('inquiry.attached_file')"
                    class="title-freight"
                  >
                    <b-form-file
                      multiple
                      accept=".pdf,.jpeg,.jpg,.png"
                      :placeholder="locals('select.attach')"
                      v-model="dataFilter.strFile"
                      @input="checkAndCompressListService('Addr', 1)"
                    />
                  </b-form-group>
                  <span v-for="(obj, index) in dataFilter.strFile">
                    <span
                      v-if="obj.strFilePath != '' && obj.strFilePath != null"
                    >
                      <a href="#" @click="onView(obj)">
                        <feather-icon
                          icon="DownloadIcon"
                          class="mr-50"
                          stroke="blue"
                          fill="blue"
                        />
                        {{ obj.name }}
                      </a>
                    </span>
                  </span>
                </b-col>
                <b-col
                  md="12"
                  class="order-sm-10 order-last"
                  v-if="strMode == 'Deliver'"
                >
                  <div class="demo-inline-spacing pt-0 justify-content-center">
                    <b-form-radio
                      v-model="dataFilter.strSelect"
                      name="some-radio9"
                      value="Completed"
                      class="custom-control-primary title-freight"
                    >
                      {{ $t("report.delivered2") }}
                    </b-form-radio>
                    <b-form-radio
                      v-model="dataFilter.strSelect"
                      name="some-radio9"
                      value="Failed"
                      class="custom-control-danger red-text"
                    >
                      {{ $t("report.fail") }}
                    </b-form-radio>
                    <br />
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-col sm="12" class="order-sm-11 order-last"> <hr /></b-col>
            <div class="d-flex justify-content-center">
              <b-row>
                <b-col sm="12">
                  <b-button
                    class="btn btn-success btn-round fixed-width mr-1"
                    v-if="strMode != 'Accept'"
                    style="margin-top: 5px"
                    @click="onConfirm"
                    :disabled="this.dataFilter.strInqJobNo == '' || ifView"
                  >
                    <span class="black-text"> {{ $t("button.save") }} </span>
                  </b-button>
                  <b-button
                    class="btn btn-round fixed-width mr-1"
                    @click="scanQRCode('Menu')"
                    style="margin-top: 5px"
                    variant="outline-dark"
                    v-if="strMode != 'Accept'"
                  >
                    <span class="black-text">
                      {{ $t("button.close") }} (ไม่บันทึก)
                    </span>
                  </b-button>
                  <b-button
                    class="btn btn-round fixed-width mr-1"
                    @click="scanQRCode('Menu')"
                    style="margin-top: 5px"
                    variant="outline-dark"
                    v-if="strMode == 'Accept'"
                  >
                    <span class="black-text"> {{ $t("button.close") }} </span>
                    <br /><br />
                    <span class="black-text">
                      ( {{ $t("button.back_menu") }})
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </transition>

    <transition name="slide-fade">
      <b-row v-if="!MenuFlag && PendingFlag">
        <b-col md="6" class="ml-auto mr-auto">
          <b-card title="รายละเอียดรายการคำขอ">
            <b-row class="pt-2">
              <b-col md="12">
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :search-options="{
                    enabled: false,
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                  styleClass="vgt-table condensed"
                >
                  <!-- Slot: Table Column -->
                  <template slot="table-column" slot-scope="props">
                    <span
                      v-if="props.column.label === 'Action'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.action") }}
                    </span>
                    <span
                      v-else-if="props.column.label === 'สถานะ'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.status") }}
                    </span>
                    <span
                      v-else-if="props.column.label === 'ชื่อลูกค้า'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.customer_name") }}
                    </span>
                    <span
                      v-else-if="props.column.label === 'ผู้สร้าง'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.create_by") }}
                    </span>
                    <span
                      v-else-if="props.column.label === 'วันที่สร้าง'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.create_date") }}
                    </span>
                    <span
                      v-else-if="props.column.label === 'ผู้แก้ไข'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.update_by") }}
                    </span>
                    <span
                      v-else-if="props.column.label === 'วันที่แก้ไข'"
                      class="text-nowrap"
                    >
                      {{ $t("inquiry.update_date") }}
                    </span>
                    <span v-else>
                      {{ props.column.label }}
                    </span>
                  </template>
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Status -->
                    <span v-if="props.column.field === 'strStatus'">
                      <div class="text-center">
                        <b-badge :variant="statusVariant2(props.row.strStatus)">
                          {{ props.row.strStatus }}
                        </b-badge>
                      </div>
                    </span>
                  </template>
                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-center flex-wrap">
                      <div class="d-flex justify-content-center flex-wrap">
                        <div class="d-flex align-items-center">
                          <b-pagination
                            :value="1"
                            :total-rows="props.total"
                            :per-page="pageLength"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mb-0 mt-1"
                            @input="
                              (pageLength) =>
                                props.pageChanged({
                                  currentPage: pageLength,
                                })
                            "
                          >
                            <template #prev-text>
                              <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                              <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                          </b-pagination>
                        </div>
                      </div>
                      <b-col sm="12"> <br /></b-col>
                      <div class="d-flex align-items-center">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['5', '10', '25']"
                          class="mx-1"
                          @input="
                            (pageLength) =>
                              props.perPageChanged({
                                currentPerPage: pageLength,
                              })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
            <b-col sm="12"> <hr /></b-col>
            <div class="d-flex justify-content-center">
              <b-row>
                <b-col sm="12">
                  <b-button
                    class="btn btn-round fixed-width mr-1"
                    @click="scanQRCode('Menu')"
                    variant="outline-dark"
                  >
                    <span class="black-text"> {{ $t("button.close") }} </span>
                    <br /><br />
                    <span class="black-text">
                      ( {{ $t("button.back_menu") }})
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </transition>

    <b-modal
      ref="show-accept"
      size="sm"
      hide-footer
      title="ตรวจสอบ QR Code ใบงาน"
    >
      <div class="d-block text-center">
        <h3 class="title-freight" v-if="strMode == 'Accept'">
          Accept / รับงาน
        </h3>
        <h3 class="title-freight" v-if="strMode == 'Deliver'">
          Deliver / ส่งงาน
        </h3>
        <h3 class="title-freight" v-if="strMode == 'Change'">รับโอนงาน</h3>
        <h3 class="title-freight" v-if="strMode == 'Return'">
          Return / คืนงาน
        </h3>
      </div>
      <div class="d-block text-left">
        <b-row>
          <b-col sm="12">
            <span class="black-text"> {{ textmsg1 }} </span> <br />
            <span class="black-text"> {{ textmsg2 }} </span><br />
            <span class="red-text"> {{ textmsg3 }} </span>
          </b-col>
        </b-row>
        <b-col sm="12"> <hr /></b-col>
        <div class="d-flex justify-content-center">
          <b-row>
            <b-col sm="12">
              <b-button
                class="btn btn-round fixed-width2 mr-1"
                @click="onSave"
                variant="success"
                v-if="!ifAPI"
              >
                <span class="black-text"> {{ $t("button.submit") }}</span>
              </b-button>
              <b-button
                class="btn btn-round fixed-width2 mr-1"
                @click="hideModal"
                variant="outline-dark"
              >
                <span class="black-text">
                  {{ $t("button.close") }} (ไม่บันทึก)</span
                >
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="custom-modal"
      title="ตรวจสอบ QR Code ใบงาน"
      size="sm"
      modal-class="modal-danger"
      ok-title="ปิด (ไม่บันทึก)"
      okVariant="danger"
      ok-only
      @ok="handleOk"
    >
      <div class="d-block text-center">
        <h3 class="title-freight" v-if="strMode == 'Accept'">
          Accept / รับงาน
        </h3>
        <h3 class="title-freight" v-if="strMode == 'Deliver'">
          Deliver / ส่งงาน
        </h3>
        <h3 class="title-freight" v-if="strMode == 'Return'">
          Return / คืนงาน
        </h3>
      </div>
      <div class="d-block text-left">
        <b-row>
          <b-col sm="12">
            <span class="black-text">
              Request Job No. : {{ dataFilter.strInqJobNo }}
            </span>
            <br />
            <span class="black-text">
              {{ $t("inquiry.status") }} : {{ dataFilter.strStatus }} </span
            ><br />
            <span class="red-text"> {{ $t("inquiry.error1") }} : </span>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { QrcodeStream } from "../../QRCodeReader";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { VueGoodTable } from "vue-good-table";
//npm install --save base64toblob
import base64toblob from "base64toblob";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import VueGeolocation from "vue-browser-geolocation";

import ReqService from "@/@API/cRequest";
import { getLoginRouteReload } from "@/auth/utils";
import { BrowserQRCodeReader } from "@zxing/library";

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
  BFormRadio,
  VBModal,
  VBTooltip,
  BModal,
  BSpinner,
  BOverlay,
} from "bootstrap-vue";

//import js from "@/views/Inquiry/Stores";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    BPagination,
    BBadge,
    BFormSelect,
    BFormRadio,
    QrcodeStream,
    VueGoodTable,
    BModal,
    BSpinner,
    BOverlay,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant2() {
      const statusColor2 = {
        Draft: "light-info",
        Submit: "light-info",
        Accept: "light-primary",
        "Delivery-Failed": "light-danger",
        "In-Completed": "light-primary",
        Return: "light-warning",
      };
      return (table_status2) => statusColor2[table_status2];
    },
  },
  mounted() {
    this.busy = true;
    this.isLoading = true;
    this.dataFilter = {
      strInqJobNo: "",
      strStatus: "",
      strNote: "",
      strFile: null,
      strSelect: "Completed",
    };
    this.onLoadWithUser();
    this.onSearch();
    this.callLocation();
  },
  data() {
    return {
      qrCodeData: null,
      vlocation: {},
      iframeSrc: "",
      iframeSrct: "",
      options: {
        penColor: "#c0f",
      },
      APIKEY: "AIzaSyAcGdDqkeJcCqh4VW1d8zrLuAJrLmJE7oY",

      table_status2: [
        {
          0: "Draft",
          1: "Submit",
          2: "Accept",
          3: "Delivery-Failed",
          4: "In-Completed",
          5: "Return",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-primary",
          3: "light-danger",
          4: "light-primary",
          5: "light-warning",
        },
      ],
      form: {},
      dataFilter: {
        strInqJobNo: "",
        strStatus: "",
        strNote: "",
        strFile: null,
        strSelect: "Completed",
      },
      destOption: [],
      MenuFlag: true,
      PendingFlag: false,
      showUsername: localStorage.getItem("username"),
      showPending: 0,
      strMode: "",
      isActiveCamStart: false,
      ifView: false,
      ifAPI: false,
      busy: true,
      processing: false,
      isLoading: true,
      textmsg1: "",
      textmsg2: "",
      textmsg3: "",
      table_status: [
        {
          0: "Draft",
          1: "DRAFT",
          2: "Save",
          3: "SAVE",
          4: "Rejected",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-success",
          3: "light-success",
          4: "light-danger",
        },
      ],
      pageLength: 5,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "ชื่อลูกค้า",
          field: "strCustomerName",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Request Job no.",
          field: "strRQMJobNo",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานะ",
          field: "strStatus",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "กำหนดจัดส่ง",
          field: "datOrderDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ประเภทงาน",
          field: "strJobType",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานที่รับ",
          field: "strRecvLocation",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานที่จัดส่ง",
          field: "strDestLocation",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้สร้าง",
          field: "strCreatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่สร้าง",
          field: "datCreatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้แก้ไข",
          field: "strUpdatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่แก้ไข",
          field: "datUpdatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้ยืนยันเอกสาร",
          field: "strLastSubmitBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่ยืนยันเอกสาร",
          field: "datLastSubmitDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้รับงานล่าสุด",
          field: "strLastAcceptBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่รับงานล่าสุด",
          field: "datLastAcceptDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    triggerFileInput2() {
      this.$refs.fileInput2.click();
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        await this.decodeQRCode(imageUrl);
        URL.revokeObjectURL(imageUrl);
      }
    },
    async decodeQRCode(imageUrl) {
      const codeReader = new BrowserQRCodeReader();
      try {
        const result = await codeReader.decodeFromImageUrl(imageUrl);
        //this.qrCodeData = result.text;
        this.onDecode(result.text);
      } catch (error) {
        console.error("QR Code not found or unreadable", error);
      }
    },
    callLocation() {
      VueGeolocation.getLocation({
        enableHighAccuracy: false, //defaults to false
        timeout: Infinity, //defaults to Infinity
        maximumAge: 0, //defaults to 0
      }).then((coordinates) => {
        this.vlocation = coordinates;
      });
    },
    onLoadWithUser() {
      let data = {
        strStatus: "Accept",
        isRider: "True",
      };
      ReqService.getSearchRequest(data)
        .then((response) => {
          console.log("Accept", response.data);
          this.showPending = response.data.length;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSearch() {
      let data = {
        strStatus: "NonDraft",
        isRider: "True",
      };

      ReqService.getSearchRequest(data)
        .then((response) => {
          console.log("NonDraft", response.data);
          this.rows = response.data;
          this.rows.forEach((q) => {
            q.datOrderDateDMY = q.datOrderDate
              ? moment(q.datOrderDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datCreatedDateDMY = q.datCreatedDate
              ? moment(q.datCreatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datUpdatedDateDMY = q.datUpdatedDate
              ? moment(q.datUpdatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datLastSubmitDateDMY = q.datLastSubmitDate
              ? moment(q.datLastSubmitDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datLastAcceptDateDMY = q.datLastAcceptDate
              ? moment(q.datLastAcceptDate).format("DD/MM/YYYY HH:mm")
              : null;

            if ((q.intJobTypeId = 1)) {
              q.strJobType = "รับเอกสาร";
            }
            if ((q.intJobTypeId = 2)) {
              q.strJobType = "ส่งเอกสาร";
            }

            let recvtext = "";
            recvtext =
              q.strRecvLocationName +
              " " +
              q.strRecvAddrName +
              " " +
              q.strRecvSubDistrict +
              " " +
              q.strRecvDistrict +
              " " +
              q.strRecvProvince +
              " " +
              q.strRecvPostCode;
            if (q.strRecvLocationNote != "" && q.strRecvLocationNote != null) {
              recvtext = recvtext + " " + q.strRecvLocationNote;
            }
            recvtext = recvtext + " " + q.strRecvContactName;
            recvtext = recvtext + " " + q.strRecvContactTelNo;
            q.strRecvLocation = recvtext;

            let desttext = "";
            desttext =
              q.strDestLocationName +
              " " +
              q.strDestAddrName +
              " " +
              q.strDestSubDistrict +
              " " +
              q.strDestDistrict +
              " " +
              q.strDestProvince +
              " " +
              q.strDestPostCode;
            if (q.strDestLocationNote != "" && q.strDestLocationNote != null) {
              desttext = desttext + " " + q.strDestLocationNote;
            }
            desttext = desttext + " " + q.strDestContactName;
            desttext = desttext + " " + q.strDestContactTelNo;
            q.strDestLocation = desttext;
          });

          this.busy = false;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    scanQRCode(mode) {
      this.MenuFlag = !this.MenuFlag;
      if (mode == "Accept") {
        this.isActiveCamStart = true;
      }
      if (mode == "Deliver") {
        this.dataFilter = {
          strInqJobNo: "",
          strStatus: "",
          strNote: "",
          strFile: null,
          strSelect: "Completed",
        };
        this.isActiveCamStart = true;
      }
      if (mode == "Return") {
        this.dataFilter = {
          strInqJobNo: "",
          strStatus: "",
          strNote: "",
          strFile: null,
          strSelect: "Return",
        };
        this.isActiveCamStart = true;
      }
      if (mode == "Change") {
        this.dataFilter = {
          strInqJobNo: "",
          strStatus: "",
          strNote: "",
          strFile: null,
          strSelect: "Change",
        };
        this.isActiveCamStart = true;
      }
      if (mode == "Menu") {
        this.dataFilter = {
          strInqJobNo: "",
          strStatus: "",
          strNote: "",
          strFile: null,
          strSelect: "Menu",
        };
        this.isActiveCamStart = false;
        this.ifView = false;
        this.PendingFlag = false;

        this.$refs["show-accept"].hide();
        this.busy = false;
        this.processing = false;
        this.isLoading = false;
        this.ifAPI = false;
      }
      if (mode == "View") {
        this.PendingFlag = true;
      }
      this.strMode = mode;
    },
    OpenCamera() {
      this.isActiveCamStart = !this.isActiveCamStart;
    },
    handleOk() {
      this.$refs["custom-modal"].hide();
      this.isActiveCamStart = true;
    },
    onDecode(result) {
      console.log("result =--->", result);

      var str = result;
      var data = "";
      data = str.replaceAll("/", "-");
      data = data.replaceAll("<", ";");
      var res = data.split(";");
      this.dataFilter.strInqJobNo = res[0];

      this.isActiveCamStart = false;
      if (this.strMode == "Accept") {
        this.onConfirm();
      }
      if (this.strMode == "Deliver") {
        this.onLoadJobNo(this.dataFilter.strInqJobNo);
      }
      if (this.strMode == "Change") {
        this.onLoadJobNo(this.dataFilter.strInqJobNo);
      }
      if (this.strMode == "Return") {
        this.onLoadJobNo(this.dataFilter.strInqJobNo);
      }
    },
    orderHandler() {
      var str = this.dataFilter.strInqJobNo;
      var data = "";
      data = str.replaceAll("/", "-");
      data = data.replaceAll("<", ";");
      var res = data.split(";");
      this.dataFilter.strInqJobNo = res[0];

      this.isActiveCamStart = false;
      if (this.strMode == "Accept") {
        this.onConfirm();
      }
      if (this.strMode == "Deliver") {
        this.onLoadJobNo(this.dataFilter.strInqJobNo);
      }
      if (this.strMode == "Change") {
        this.onLoadJobNo(this.dataFilter.strInqJobNo);
      }
      if (this.strMode == "Return") {
        this.onLoadJobNo(this.dataFilter.strInqJobNo);
      }
    },
    hideModal() {
      this.$refs["show-accept"].hide();
      if (this.strMode == "Accept") {
        this.isActiveCamStart = true;
      }
    },
    callDestLocation(id, jobno) {
      this.destOption = [];
      ReqService.getDestLocationRequestByJobNo({
        intRequestId: id,
        strInqJobNo: jobno,
      })
        .then((response) => {
          response.data.destList.forEach((dat) => {
            let desttext = "";
            desttext =
              dat.strDestLocationName +
              " : " +
              dat.strDestAddrName +
              " " +
              dat.strDestSubDistrict +
              " " +
              dat.strDestDistrict +
              " " +
              dat.strDestProvince +
              " " +
              dat.strDestPostCode;
            if (
              dat.strDestLocationNote != "" &&
              dat.strDestLocationNote != null
            ) {
              desttext = desttext + " " + dat.strDestLocationNote;
            }
            desttext = desttext + " " + dat.strDestContactName;
            desttext = desttext + " " + dat.strDestContactTelNo;
            dat.strDestLocation = desttext;
          });
          this.destOption = response.data.destList;
        })
        .catch((error) => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onLoadJobNo(jobno) {
      this.busy = true;
      this.isLoading = true;

      ReqService.getFormRequestByJobNo({
        strInqJobNo: jobno,
      })
        .then((response) => {
          this.busy = false;
          this.isLoading = false;

          this.form = response.data.headerGrid;
          console.log("response.data", response.data);

          if (this.strMode == "Deliver") {
            console.log("this.form.intRequestId", this.form.intRequestId);
            this.callDestLocation(this.form.intRequestId, jobno);
          }

          if (this.strMode == "Change") {
            if (this.form.datLastDeliveredDate == null) {
              this.dataFilter.strUpdatedDateDMY = this.form.datLastAcceptDate
                ? moment(this.form.datLastAcceptDate).format("DD/MM/YYYY HH:mm")
                : null;
              this.dataFilter.strUpdatedBy = this.form.strLastAcceptBy;
            } else {
              this.dataFilter.strUpdatedDateDMY = this.form.datLastDeliveredDate
                ? moment(this.form.datLastDeliveredDate).format(
                    "DD/MM/YYYY HH:mm"
                  )
                : null;
              this.dataFilter.strUpdatedBy = this.form.strLastDeliveredBy;
            }
          }

          this.dataFilter.strStatus = this.form.strStatus;
          if (
            this.form.strStatus == "Draft" ||
            this.form.strStatus == "Submit" ||
            this.form.strStatus == "Delivered" ||
            this.form.strStatus == "Return"
          ) {
            this.ifView = true;
          }
          if (
            (this.strMode == "Deliver" ||
              this.strMode == "Return" ||
              this.strMode == "Change") &&
            (this.form.strStatus == "Draft" ||
              this.form.strStatus == "Submit" ||
              this.form.strStatus == "Completed" ||
              this.form.strStatus == "Delivered" ||
              this.form.strStatus == "Return")
          ) {
            this.$refs["custom-modal"].show();
          }
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onConfirm() {
      let lang = localStorage.getItem("language");

      this.$refs["show-accept"].show();

      let stsEn;
      let stsTh;
      if (this.strMode == "Accept") {
        stsEn = "Accept";
        stsTh = "รับงาน";
      }
      if (this.strMode == "Deliver") {
        stsEn = "Deliver";
        stsTh = "ส่งเอกสาร";
      }
      if (this.strMode == "Change") {
        stsEn = "Accept";
        stsTh = "รับโอนงาน";
      }
      if (this.strMode == "Return") {
        stsEn = "Return";
        stsTh = "ส่งคืน";
      }

      let enmsg1 = "Request Job No. : " + this.dataFilter.strInqJobNo;
      let enmsg2 = "Status : " + stsEn;
      let thmsg1 = "เลขที่ใบงาน : " + this.dataFilter.strInqJobNo;
      let thmsg2 = "สถานะ : " + stsTh;

      if (lang == "th_TH") {
        this.textmsg1 = thmsg1;
        this.textmsg2 = thmsg2;
        this.textmsg3 = "";
      } else {
        this.textmsg1 = enmsg1;
        this.textmsg2 = enmsg2;
        this.textmsg3 = "";
      }

      this.ifAPI = false;
    },
    onSave() {
      let lang = localStorage.getItem("language");

      let enmsg1 = "Request Job No. : " + this.dataFilter.strInqJobNo;
      let enerrmsg1 = "Request Job No. : " + this.dataFilter.strInqJobNo;
      let ennullmsg1 = "Request Job No. : -";
      let enmsg2 = "Status: Accept";
      let enerrmsg2 = "Status: Draft";
      let ennullmsg2 = "Status: -";

      let thmsg1 = "เลขที่ใบงาน: " + this.dataFilter.strInqJobNo;
      let therrmsg1 = "เลขที่ใบงาน: " + this.dataFilter.strInqJobNo;
      let thnullmsg1 = "เลขที่ใบงาน: ";
      let thmsg2 = "สถานะ: รับงาน";
      let therrmsg2 = "สถานะ: ร่าง";
      let thnullmsg2 = "สถานะ: -";

      this.$refs["show-accept"].hide();
      this.busy = true;
      this.processing = true;
      this.ifAPI = true;

      this.callLocation();

      if (this.strMode == "Deliver") {
        let confirm_file = [];
        let confirm_file_raw = [];
        let addrstartcountfile = 0;
        // file
        if (this.dataFilter.strFile != null) {
          this.dataFilter.strFile.forEach((file, fileindex) => {
            let ffname = "Deli//" + file.name;
            let type = file.name.split(".");
            let intDId = -1;
            let fileobj = {
              intDetailId: intDId,
              intCustomerId: this.form.intRequestId,
              intAddrId: -1,
              intItemId: fileindex,
              intAllItemId: addrstartcountfile,
              intFileIndex: 1,
              strFileFromService: "Deli",
              strFreightFileName: file.name,
              strFileName: file.name,
              filesize: file.size,
              strFileType: file.type,
            };
            confirm_file.push(fileobj);
            confirm_file_raw.push(file);
            addrstartcountfile++;
          });
        }

        this.isSaving = true;
        var dataSave = {
          strInqJobNo: this.dataFilter.strInqJobNo,
          intRequestId: this.form.intRequestId,
          intDestBPId: this.dataFilter.intDestBPId,
          strNote: this.dataFilter.strNote,
          strSelect: this.dataFilter.strSelect,
          addrFile: confirm_file,
          strLocationAcc: this.vlocation.accuracy,
          strLocationAlt: this.vlocation.altitude,
          strLocationAltAcc: this.vlocation.altitudeAccuracy,
          strLocationLat: this.vlocation.lat,
          strLocationLng: this.vlocation.lng,
        };
        console.log("dataSave", dataSave);

        let formData = new FormData();
        confirm_file_raw.forEach((x) => {
          formData.append("files", x);
        });
        formData.append("strJson", JSON.stringify(dataSave));

        ReqService.saveDeliverRequest(formData)
          .then((response) => {
            if (response.data == "ไม่พบเอกสาร") {
              this.busy = false;
              this.processing = false;
              if (lang == "th_TH") {
                this.textmsg1 = ennullmsg1;
                this.textmsg2 = ennullmsg2;
                this.textmsg3 = response.data;
              } else {
                this.textmsg1 = thnullmsg1;
                this.textmsg2 = thnullmsg2;
                this.textmsg3 = response.data;
              }
              this.$refs["show-accept"].show();
            } else if (response.data == "ใบงานไม่อยู่ในสภาพพร้อมใช้งาน") {
              this.busy = false;
              this.processing = false;
              if (lang == "th_TH") {
                this.textmsg1 = enerrmsg1;
                this.textmsg2 = enerrmsg2;
                this.textmsg3 = response.data;
              } else {
                this.textmsg1 = therrmsg1;
                this.textmsg2 = therrmsg2;
                this.textmsg3 = response.data;
              }
              this.$refs["show-accept"].show();
            } else if (
              response.data == "ใบงานยังไม่ถูกรับ" ||
              response.data == "ใบงานถูกรับไปแล้ว" ||
              response.data == "ใบงานเสร็จสิ้นแล้ว" ||
              response.data == "ใบงานนี้ถูกรับงานโดย Rider อื่น"
            ) {
              this.busy = false;
              this.processing = false;
              if (lang == "th_TH") {
                this.textmsg1 = enmsg1;
                this.textmsg2 = enmsg2;
                this.textmsg3 = response.data;
              } else {
                this.textmsg1 = thmsg1;
                this.textmsg2 = thmsg2;
                this.textmsg3 = response.data;
              }
              this.$refs["show-accept"].show();
            } else {
              let finalmsg;
              if (this.strMode == "Deliver") {
                finalmsg = "บันทึกงานสำเร็จ";
              }
              //location.reload();
              //this.$router.replace(getLoginRouteReload()).then(() => {
              //});

              this.$refs["show-accept"].hide();
              this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "ผลการบันทึก",
                      variant: "success",
                      text: finalmsg,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
                this.scanQRCode("Menu");
            }
          })
          .catch((error) => {
            console.log("error", error);
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: "Something was wrong : " + error,
                },
              },
              {
                position: "top-center",
              }
            );
          });
      }
      if (this.strMode == "Accept" || this.strMode == "Return") {
        ReqService.getResponseAcceptAndReturnRequest({
          strInqJobNo: this.dataFilter.strInqJobNo,
          strStatus: this.strMode,
          strLocationAcc: this.vlocation.accuracy,
          strLocationAlt: this.vlocation.altitude,
          strLocationAltAcc: this.vlocation.altitudeAccuracy,
          strLocationLat: this.vlocation.lat,
          strLocationLng: this.vlocation.lng,
        })
          .then((response) => {
            if (response.data == "ไม่พบเอกสาร") {
              this.busy = false;
              this.processing = false;
              if (lang == "th_TH") {
                this.textmsg1 = ennullmsg1;
                this.textmsg2 = ennullmsg2;
                this.textmsg3 = response.data;
              } else {
                this.textmsg1 = thnullmsg1;
                this.textmsg2 = thnullmsg2;
                this.textmsg3 = response.data;
              }
              this.$refs["show-accept"].show();
            } else if (response.data == "ใบงานไม่อยู่ในสภาพพร้อมใช้งาน") {
              this.busy = false;
              this.processing = false;
              if (lang == "th_TH") {
                this.textmsg1 = enerrmsg1;
                this.textmsg2 = enerrmsg2;
                this.textmsg3 = response.data;
              } else {
                this.textmsg1 = therrmsg1;
                this.textmsg2 = therrmsg2;
                this.textmsg3 = response.data;
              }
              this.$refs["show-accept"].show();
            } else if (
              response.data == "ใบงานยังไม่ถูกรับ" ||
              response.data == "ใบงานถูกรับไปแล้ว" ||
              response.data == "ใบงานเสร็จสิ้นแล้ว" ||
              response.data == "ใบงานนี้ถูกรับงานโดย Rider อื่น"
            ) {
              this.busy = false;
              this.processing = false;
              if (lang == "th_TH") {
                this.textmsg1 = enmsg1;
                this.textmsg2 = enmsg2;
                this.textmsg3 = response.data;
              } else {
                this.textmsg1 = thmsg1;
                this.textmsg2 = thmsg2;
                this.textmsg3 = response.data;
              }
              this.$refs["show-accept"].show();
            } else {
              let finalmsg;
              if (this.strMode == "Accept") {
                finalmsg = "รับงานสำเร็จ";
              }
              if (this.strMode == "Return") {
                finalmsg = "ส่งคืนงานสำเร็จ";
              }
              //location.reload();
              //this.$router.replace(getLoginRouteReload()).then(() => {
              //});

              this.$refs["show-accept"].hide();
              this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "ผลการบันทึก",
                      variant: "success",
                      text: finalmsg,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
                this.scanQRCode("Menu");
            }
          })
          .catch((error) => {
            console.log("error", error);
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: "Something was wrong : " + error,
                },
              },
              {
                position: "top-center",
              }
            );
          });
      }
      if (this.strMode == "Change") {
        if (this.showUsername == this.dataFilter.strUpdatedBy) {
          if (lang == "th_TH") {
            this.textmsg1 = enmsg1;
            this.textmsg2 = enmsg2;
            this.textmsg3 = "เป็นผู้ดำเนินการอยู่แล้ว";
          } else {
            this.textmsg1 = thmsg1;
            this.textmsg2 = thmsg2;
            this.textmsg3 = "Already Accepted Request.";
          }
          this.busy = false;
          this.processing = false;
          this.$refs["show-accept"].show();
          return;
        } else {
          ReqService.getResponseChangeRequest({
            strInqJobNo: this.dataFilter.strInqJobNo,
            strStatus: this.strMode,
            strLocationAcc: this.vlocation.accuracy,
            strLocationAlt: this.vlocation.altitude,
            strLocationAltAcc: this.vlocation.altitudeAccuracy,
            strLocationLat: this.vlocation.lat,
            strLocationLng: this.vlocation.lng,
          })
            .then((response) => {
              if (response.data == "ไม่พบเอกสาร") {
                this.busy = false;
                this.processing = false;
                if (lang == "th_TH") {
                  this.textmsg1 = ennullmsg1;
                  this.textmsg2 = ennullmsg2;
                  this.textmsg3 = response.data;
                } else {
                  this.textmsg1 = thnullmsg1;
                  this.textmsg2 = thnullmsg2;
                  this.textmsg3 = response.data;
                }
                this.$refs["show-accept"].show();
              } else if (response.data == "ใบงานไม่อยู่ในสภาพพร้อมใช้งาน") {
                this.busy = false;
                this.processing = false;
                if (lang == "th_TH") {
                  this.textmsg1 = enerrmsg1;
                  this.textmsg2 = enerrmsg2;
                  this.textmsg3 = response.data;
                } else {
                  this.textmsg1 = therrmsg1;
                  this.textmsg2 = therrmsg2;
                  this.textmsg3 = response.data;
                }
                this.$refs["show-accept"].show();
              } else if (
                response.data == "ใบงานยังไม่ถูกรับ" ||
                response.data == "ใบงานเสร็จสิ้นแล้ว" ||
                response.data == "ใบงานถูกรับแล้ว" ||
                response.data ==
                  "ใบงานนี้เป็นใบงาน 1 จุด ไม่สามารถรับโอนงานต่อได้"
              ) {
                this.busy = false;
                this.processing = false;
                if (lang == "th_TH") {
                  this.textmsg1 = enmsg1;
                  this.textmsg2 = enmsg2;
                  this.textmsg3 = response.data;
                } else {
                  this.textmsg1 = thmsg1;
                  this.textmsg2 = thmsg2;
                  this.textmsg3 = response.data;
                }
                this.$refs["show-accept"].show();
              } else {
                let finalmsg;
                finalmsg = "รับโอนงานสำเร็จ";
                //location.reload();
                //this.$router.replace(getLoginRouteReload()).then(() => {
                 //}); 
              this.$refs["show-accept"].hide();
              this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "ผลการบันทึก",
                      variant: "success",
                      text: finalmsg,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
                this.scanQRCode("Menu");
              }
            })
            .catch((error) => {
              console.log("error", error);
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "Something was wrong",
                    icon: "FrownIcon",
                    variant: "danger",
                    text: "Something was wrong : " + error,
                  },
                },
                {
                  position: "top-center",
                }
              );
            });
        }
      }
    },
    tbuildFile(blob, name) {
      return new File([blob], name);
    },
    ttoBlob(imgUrl) {
      let blob = base64toblob(imgUrl.split(",")[1], "image/jpeg");
      let url = window.URL.createObjectURL(blob);
      return url;
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      var byteString = atob(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to an ArrayBuffer
      var arrayBuffer = new ArrayBuffer(byteString.length);
      var _ia = new Uint8Array(arrayBuffer);
      for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
      }
      var dataView = new DataView(arrayBuffer);
      var blob = new Blob([dataView], { type: mimeString });
      return blob;
    },
    compressImage(mode, input, index, fileindex) {
      let file;

      file = this.dataFilter.strFile[fileindex];

      let imageData = null;
      let context = null;
      let maxWidth = 2400;
      let maxHeigt = 2400;
      let width = maxWidth;
      let height = maxHeigt;
      let vm = this;

      let reader = new FileReader();
      let name = file.name;

      let img = new Image();
      var canvas = document.createElement("canvas");
      reader.onload = function (e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      img.onload = function () {
        // Draw
        context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);

        if (img.width > maxWidth || img.height > maxHeigt) {
          width = maxWidth;
          height = maxHeigt;

          if (img.width > maxWidth) {
            width = maxWidth;
            var ration = maxWidth / img.width;
            height = Math.round(img.height * ration);
          }

          if (img.height > maxHeigt) {
            height = maxHeigt;
            var ration = maxHeigt / img.height;
            width = Math.round(img.width * ration);
          }
        } else {
          width = img.width;
          height = img.height;
        }
        canvas.width = width;
        canvas.height = height;

        context.drawImage(img, 0, 0, width, height);

        var objToPass = {};

        // Quality Of Image
        let quality = 100 / 100;
        imageData = canvas.toDataURL("image/jpeg", quality);
        imageData.replace("data:image/jpeg;base64,", "");
        let tblobToFile = vm.ttoBlob(imageData);
        let blobToFile = vm.dataURItoBlob(imageData);

        //console.log("imageData", imageData);
        //console.log(tblobToFile);
        //console.log(blobToFile);

        for (let qty = 100; blobToFile.size > 1048576 && qty > 0; ) {
          qty = qty - 10;
          quality = qty / 100;
          imageData = canvas.toDataURL("image/jpeg", quality);
          imageData.replace("data:image/jpeg;base64,", "");
          tblobToFile = vm.ttoBlob(imageData);
          blobToFile = vm.dataURItoBlob(imageData);
        }

        vm.dataFilter.strFile[fileindex] = vm.tbuildFile(imageData, name);
      };
    },
    async checkAndCompressListService(mode, input) {
      if (this.dataFilter.strFile != null) {
        this.dataFilter.strFile.forEach((file, fileindex) => {
          if (file.size > 1048576 && file.type.startsWith("image/")) {
            let filename = file.name;
            let title =
              "The file " +
              filename +
              " is larger than 1 MB. Do you want to compress it?";
            this.$bvModal
              .msgBoxConfirm(title, {
                title: "Compress Image?",
                size: "m",
                modalClass: "modal-success",
                okVariant: "success",
                okTitle: "Compress",
                cancelTitle: "Cancel",
                cancelVariant: "outline-warning",
                hideHeaderClose: false,
                //centered: true,
              })
              .then((value) => {
                if (value) {
                  this.compressImage(mode, 1, index, fileindex);
                } else {
                  this.dataFilter.strFile = null;
                }
              });
          }
        });
      }
    },
    onView(url) {
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:9090";
      window.open(`${baseUrl}api/v1/fpview/Deli/${url.strFileName}`, "_blank");
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";

.vgt-table th {
  font-size: 14px; /* Adjust the font size as needed */
}

.vgt-table td {
  font-size: 14px; /* Adjust the font size as needed */
}

.black-text {
  color: black;
}

.title-text {
  color: #3f51b5 !important;
  //font-weight: 400 !important;
  label {
    color: #3f51b5 !important;
  }
}

.red-text {
  color: red !important;
  //font-weight: 400 !important;
  font-size: 0.97rem !important;
  label {
    color: red !important;
    font-size: 0.97rem !important;
  }
}

.larger-font {
  font-size: larger;
}

.smaller-font {
  font-size: smaller;
}

.fixed-width {
  width: 160px;
}

.fixed-width2 {
  width: 130px;
}
</style>
